import { useState, useEffect } from 'react';

function useValueStore(store) {
  const [value, setValue] = useState(() => store.get());
  useEffect(() => store.onChange(setValue), [store]);
  return value;
}

export { useValueStore as default };
//# sourceMappingURL=useValueStore.js.map
